import React, { Fragment, useState } from 'react';
import axios from 'axios';
import { Controller } from 'react-hook-form';
import PlacesAutocomplete, {
  geocodeByPlaceId
} from 'react-places-autocomplete';
import styles from './Field.module.sass';
import Typography from '../../Typography';

const querySimilarAddresses = async (address) => {
  const res = await axios.get(`/orders/similar_address?address=${address}`);

  return res.data.count > 0
}

const PlacesAutocompleteField = ({  inputClassName, setValue, control, inputName }) => {
  const [address, setAddress] = useState('');
  const [hasSimilarAddress, setHasSimilarAddress] = useState(false)

  const handleSelect = async (address, placeId) => {
    const [place] = await geocodeByPlaceId(placeId);
    const { long_name: postalCode = '' } = place.address_components.find(c => c.types.includes('postal_code')) || {};
    const { long_name: streetNumber = '' } = place.address_components.find(c => c.types.includes('street_number')) || {};
    const { long_name: street = '' } = place.address_components.find(c => c.types.includes('route')) || {};
    const { long_name: city = '' } = place.address_components.find(c => c.types.includes('locality')) || {};
    const { short_name: stateAbbreviation = '' } = place.address_components.find(c => c.types.includes('administrative_area_level_1')) || {};

    if (inputName === 'shipping_address') {
      setValue('shipping_address', `${streetNumber} ${street}`);
      setValue('shipping_city', city);
      setValue('shipping_zip', postalCode);
      setValue('shipping_state', { value: stateAbbreviation, label: stateAbbreviation });
    } else {
      setValue('address', `${streetNumber} ${street}`);
      setValue('city', city);
      setValue('zip_code', postalCode);
      setValue('state', { value: stateAbbreviation, label: stateAbbreviation });
    }
  };

  const renderSuggestions = (suggestions, getSuggestionItemProps) => (
    suggestions.map(suggestion => {
      const className = suggestion.active
        ? `suggestion-item--active ${styles.dropdownItem}`
        : `suggestion-item ${styles.dropdownItem}`;
      // inline style for demonstration purpose
      const style = suggestion.active
        ? { backgroundColor: '#fafafa', cursor: 'pointer' }
        : { backgroundColor: '#ffffff', cursor: 'pointer' };
      return (
        <div
          {...getSuggestionItemProps(suggestion, {
            className,
            style,
          })}
        >
          <span>{suggestion.description}</span>
        </div>
      );
    })
  );

  return (
    <Controller
      control={control}
      name={inputName}
      value={address}
      onChange={e => setAddress(e.target.value)}
      render={({ field: { onChange, value } }) => {
        return (
          <div onBlur={async (evt) => {
            const hasSimilar = await querySimilarAddresses(evt.target.value)

            setHasSimilarAddress(hasSimilar)
          }}>
            <PlacesAutocomplete
              value={value || ''}
              onChange={onChange}
              onSelect={handleSelect}
              searchOptions={{ location: new google.maps.LatLng(37.6, -120.9), types: ['address'], radius: 5000 }}
            >
              {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                <Fragment>
                  <input
                    value={value}
                    className={`${styles.input} ${inputClassName}`}
                    {...getInputProps()}
                  />
                  <div className={`autocomplete-dropdown-container ${styles.selectContainer}`}>
                    {loading && <div>Loading...</div>}
                    {renderSuggestions(suggestions, getSuggestionItemProps)}
                  </div>
                </Fragment>
              )}
            </PlacesAutocomplete>
            {hasSimilarAddress && (
              <Typography style={{ color: '#ff3434', padding: '0.25em 0 0.75em' }}>
                Does this address has a Unit / APT number?
              </Typography>
            )}
          </div>
        )
      }}
    />
  );
};

export default PlacesAutocompleteField;
